import * as React from 'react';
import { OverreadChallengeStatusEnum, OverreadStatusIdEnum } from '../../api/apiTypes';

interface AnalysisAcceptabilityStatusProps {
    value: string;
}

export class AnalysisAcceptabilityStatus extends React.Component<AnalysisAcceptabilityStatusProps> {
    constructor(props: AnalysisAcceptabilityStatusProps) {
        super(props);
    }

    render() {
        let colour, name;

        switch (this.props.value) {
            case OverreadStatusIdEnum.Pending:
                colour = 'warning';
                name = 'Pending';
                break;
            case OverreadStatusIdEnum.Accepted:
                colour = 'success';
                name = 'Accepted';
                break;
            case OverreadStatusIdEnum.Rejected:
                colour = 'danger';
                name = 'Rejected';
                break;
            default:
                colour = 'primary';
                name = 'Not started';
        }

        return (
            <span className={'label label-' + colour}>{name}</span>
        );
    }
}
